import React from 'react';

export interface SpacerProps {
  height?: string;
  minHeight?: string;
  style?: React.CSSProperties;
}

/**
 * 余白を指定した高さ、幅などで埋めるためのコンポーネント
 * @param height 高さ
 * @param minHeight 最小高さ
 * @param style CSSプロパティなどの設定
 * @returns
 */

const Spacer: React.FC<SpacerProps> = ({ height, minHeight, style = {} }) => {
  return <div style={{ height: height, minHeight: minHeight, ...style }}></div>;
};

export default Spacer;
